import styles from "../../../constructionNew/components/tagControl/ConstructionNewTagControl.module.scss";
import { useState } from 'react';
import type CalculationTagsPropsNew from './CalculationTagsPropsNew';
import { useAuth } from '../../../../services/auth/hooks/useAuth';
import { IconButton } from "@fluentui/react";
import ConfirmTagDeletionDialogNew from "../../../../components/isaacTagsDialogsNew/deletion/ConfirmTagDeletionDialogNew";
import AddTagsDialogNew from "../../../../components/isaacTagsDialogsNew/addition/AddTagsDialogNew";

const CalculationTagsNew: React.FunctionComponent<CalculationTagsPropsNew> = ({
    construction
}) => {
    const { tags } = construction;
    const [isAddDialogHidden, setIsAddDialogHidden] = useState<boolean>(true);
    const [isDeleteDialogHidden, setIsDeleteDialogHidden] = useState<boolean>(true);
    const [tagToDelete, setTagToDelete] = useState<string>();
    const {user} = useAuth();
    const isAllowedToTakeAction = user?.isAllowedToTakeAction();

    const handleAddDialogDismiss = (): void => {
        setIsAddDialogHidden(true);
    };

    const handleDeleteDialogDismiss = (): void => {
        setIsDeleteDialogHidden(true);
    };

    return (
        <>
          <ul className={styles.tagsContainer}>
            {tags?.map((tag, index) => {
              return (
                isAllowedToTakeAction && (
                  <li className={styles.tag} key={index}>
                    <span className={styles.name}>{tag.value}</span>
                    <span className={styles.removeBtn}>
                      <IconButton
                        iconProps={{iconName: "Clear"}}
                        title="Remove"
                        ariaLabel="Remove"
                        id="tag"
                        onClick={() => {
                          setTagToDelete(tag.value);
                          setIsDeleteDialogHidden(false);
                        }}
                      />
                    </span>
                  </li>
                )
              );
            })}
            {isAllowedToTakeAction && (
              <li key="add" className={`${styles.tag} ${styles.bordered}`}>
                <span className={styles.addBtn}>
                  <IconButton
                    iconProps={{iconName: "Add"}}
                    title="Add new tag"
                    ariaLabel="Add new tag"
                    onClick={() => {
                      setIsAddDialogHidden(false);
                    }}
                  />
                </span>
              </li>
            )}
          </ul>
    
          <ConfirmTagDeletionDialogNew
            isHidden={isDeleteDialogHidden}
            handleDismiss={handleDeleteDialogDismiss}
            tag={tagToDelete}
            constructionId={construction.id}
          />
    
          <AddTagsDialogNew
            isHidden={isAddDialogHidden}
            handleDismiss={handleAddDialogDismiss}
          />
        </>
      );
};

export default CalculationTagsNew;